import React from 'react';
import { Card } from '@clockout-dev/design-elements';
import SummaryHeader from './elements/SummaryHeader';
import PayrollSummarySection from './elements/PayrollSummarySection';
import ThresholdProgressSection from './elements/ThresholdProgressSection';
import DeductionsSection from './elements/DeductionsSection';
import FinalBalanceSection from './elements/FinalBalanceSection';
import styles from './styles/availableBalanceSummaryCard.module.scss';

function AvailableBalanceSummaryCard({ summary = {} }) {
    const {
        grossPay = 0,
        payrollDeductions = 0,
        netPay = 0,
        threshold = 0,
        userTenureValue = 0,
        overdraftValue = 0,
        achValue = 0,
        employmentValue = 0,
        balanceValue = 0,
        finalThreshold = 0,
        availableBalance = 0,
    } = summary;

    return (
        <Card className={styles.summaryCard}>
            <SummaryHeader />
            <PayrollSummarySection
                grossPay={grossPay}
                payrollDeductions={payrollDeductions}
                netPay={netPay}
            />
            <ThresholdProgressSection thresholdPercent={threshold} />
            <DeductionsSection
                userTenureValue={userTenureValue}
                overdraftValue={overdraftValue}
                achValue={achValue}
                employmentValue={employmentValue}
                balanceValue={balanceValue}
                finalThreshold={finalThreshold}
            />
            <FinalBalanceSection availableBalance={availableBalance} />
        </Card>
    );
}

export default AvailableBalanceSummaryCard;
